import { render, staticRenderFns } from "./LectureListPage.vue?vue&type=template&id=349c3974&scoped=true"
import script from "./LectureListPage.vue?vue&type=script&lang=js"
export * from "./LectureListPage.vue?vue&type=script&lang=js"
import style0 from "./LectureListPage.vue?vue&type=style&index=0&id=349c3974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c3974",
  null
  
)

export default component.exports